class ProfileSecurity {
}

export default {
  name: 'bp-profile-security',
  viewModel: ProfileSecurity,
  template: require('./security.html')
};
